import React, { useState } from 'react';
import { Typography } from 'antd';
import { api, utils, components } from '@seaoil/component-lib';
import { LayoutWithNav } from '../../components/Layout';

const { Title } = Typography;
const { mySEAOIL } = api;
const { logger } = utils;
const { Auth } = components;

function ApiKey() {
  const AuthContext = Auth.useContext();

  const [state, setState] = useState({
    status: 'initializing',
    key: '...',
    generated_at: '...',
  });

  if (AuthContext.status === 'LOGGED_IN'
    && state.status === 'initializing') {
    logger.info('Getting API Key');
    mySEAOIL.iam.getApiKey().send()
      .then((data) => {
        logger.debug(data);
        setState({
          ...(data || {}),
          status: 'ready',
        });
      });
  }

  const generate = () => {
    logger.info('clicked');
    if (state.status !== 'ready') return;
    setState((curr) => ({
      ...curr,
      key: '...',
      generated_at: '...',
      status: 'generating',
    }));

    logger.info('Generating API Key');
    mySEAOIL.iam.generateApiKey().send()
      .then((data) => {
        logger.debug(data);
        setState({
          ...(data || {}),
          status: 'ready',
          warn: true,
        });
      });
  };

  logger.debug({ STATE: state, auth: AuthContext });

  return (
    <Auth.PrivateComponent redirect="/login">
      <LayoutWithNav>
        <Title>API Key</Title>
        <div>
          <span>API Key:</span>
          <pre>{state.key}</pre>
          <span>Generated At:</span>
          <pre>{state.generated_at}</pre>
        </div>
        <div
          style={{
            display: (state.warn ? 'inherit' : 'none'),
            padding: '10px',
            color: 'red',
          }}
        >
          Warning: Keep the API in a safe place, you won&apos;t be able to see the key again!
        </div>
        <button type="button" onClick={generate}>Generate</button>
      </LayoutWithNav>
    </Auth.PrivateComponent>
  );
}

export default ApiKey;
